import CryptoJS from "crypto-js";

// --------------------------------------------------
// AES CONFIG
// --------------------------------------------------
const KEY = "INMATEINBOX987654321";   // 24 chars → AES-192 OK for CryptoJS
const IV = "1234567890980563";       // 16 chars → valid IV

const key = CryptoJS.enc.Utf8.parse(KEY);
const iv = CryptoJS.enc.Utf8.parse(IV);

// --------------------------------------------------
// Encrypt
// --------------------------------------------------
export function encryptData(text) {
    try {
        const encrypted = CryptoJS.AES.encrypt(text, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        return encrypted.toString(); // Base64
    } catch (err) {
        console.error("Encrypt error:", err);
        return null;
    }
}

// --------------------------------------------------
// Decrypt
// --------------------------------------------------
export function decryptData(cipherText) {
    try {
        if (!cipherText) return null;

        const bytes = CryptoJS.AES.decrypt(cipherText, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        return decrypted || null;
    } catch (err) {
        console.error("Decrypt error:", err);
        return null;
    }
}

// --------------------------------------------------
// Get value (localStorage → sessionStorage)
// auto decrypt + parse JSON
// --------------------------------------------------
export const getStoredValue = (key) => {
    try {
        let encrypted =
            localStorage.getItem(key) ||
            sessionStorage.getItem(key);

        if (!encrypted) return null;

        const decrypted = decryptData(encrypted);
        if (!decrypted) return null;

        return JSON.parse(decrypted);
    } catch (err) {
        console.error(`Error reading key "${key}"`, err);
        return null;
    }
};

// --------------------------------------------------
// Set value (encrypt + store)
// Desktop → localStorage + sessionStorage (optional)
// --------------------------------------------------
export const setStoredValue = (key, value, useSessionStorage = true) => {
    try {
        const platform = navigator?.userAgentData?.platform ||  navigator?.platform ||  "unknown";

        const isDesktop =  platform.toLowerCase().includes("win") ||  platform.toLowerCase().includes("mac") ||  platform.toLowerCase().includes("linux");

        const json = JSON.stringify(value);
        const encrypted = encryptData(json);
        if (!encrypted) return;

        // Desktop → localStorage
        if (isDesktop) {
            localStorage.setItem(key, encrypted);
        }

        // Browser tab-level
        if (useSessionStorage) {
            sessionStorage.setItem(key, encrypted);
        }
    } catch (err) {
        console.error(`Error setting key "${key}"`, err);
    }
};

// --------------------------------------------------
// Remove value
// --------------------------------------------------
export const removeStoredValue = (key) => {
    try {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    } catch (err) {
        console.error(`Error removing key "${key}"`, err);
    }
};
